import React from 'react';
import {Modal, Row, Col} from 'react-bootstrap';

const InfoModal = ({customTitle, customMsg, onCancel, showModal, confirmButtonTitle}) => {
  return (
    <Modal show={showModal} onHide={onCancel} backdrop="static" className="confirmModal">
      <Modal.Header closeButton>
        <Modal.Title>
          <Row>
            <Col md={12} className="modal-title">
              {customTitle || 'Info'}
            </Col>
          </Row>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mt-3 text-center font-size-20">{customMsg || 'Info'}</p>
      </Modal.Body>
      <Modal.Footer className="mt-3 text-center">
        <button className="btn btn-primary" type="button" onClick={()=>{ onCancel()}}>{confirmButtonTitle || 'Ok'}</button>
      </Modal.Footer>
    </Modal>
  );
};


export default InfoModal;



// WEBPACK FOOTER //
// ./src/components/common/InfoModal.js